import * as Immutable from 'immutable';
import {
  LIST_CONTACTS_REQUESTED,
  LIST_CONTACTS_COMPLETED,
  LIST_CONTACTS_FAILED,
  LIST_CONTACTS_ABORTED,
  RESET_CONTACT_REQUESTED,
  RESET_CONTACT_COMPLETED,
  SET_CONTACT_REQUESTED,
  SET_CONTACT_COMPLETED,
  SET_CONTACT_ABORTED,
  SET_CONTACT_FAILED,
  SET_CONTACT_REDIRECT_REQUESTED,
  SET_CONTACT_REDIRECT_COMPLETED,
  SET_CONTACT_REDIRECT_ABORTED,
  SET_CONTACT_REDIRECT_FAILED,
  SET_CONTACT_REDIRECT_ASSERT_REQUESTED,
  SET_CONTACT_REDIRECT_ASSERT_COMPLETED,
  SET_CONTACT_REDIRECT_ASSERT_ABORTED,
  SET_CONTACT_REDIRECT_ASSERT_FAILED,
  SET_CONTACT_REDIRECTRESET_COMPLETED,
  SET_CONTACTID_ACTION_REQUESTED,
  SET_CONTACTID_ACTION_COMPLETED,
  SET_CONTACTID_ACTION_FAILED,
  SET_CONTACT_REDIRECTACTION_REQUESTED,
  SET_CONTACT_REDIRECTACTION_COMPLETED,
  SET_CONTACT_REDIRECTACTION_ABORTED,
  SET_CONTACT_REDIRECTACTION_FAILED,
  SET_CONTACT_REDIRECTROUTE_REQUESTED,
  SET_CONTACT_REDIRECTROUTE_COMPLETED,
  SET_CONTACT_REDIRECTROUTE_ABORTED,
  SET_CONTACT_REDIRECTROUTE_FAILED,
  RESET_CONTACT_REDIRECTROUTE_COMPLETED,
  SET_CONTACT_REDIRECTONEVIEW_STATUSES_REQUESTED,
  SET_CONTACT_REDIRECTONEVIEW_STATUSES_COMPLETED,
  SET_CONTACT_REDIRECTONEVIEW_STATUSES_ABORTED,
  SET_CONTACT_REDIRECTONEVIEW_STATUSES_FAILED,
  RESET_CONTACT_REDIRECTACTION_COMPLETED,
  SET_CONTACT_ACTIVATEACCOUNTROUTE_REQUESTED,
  SET_CONTACT_ACTIVATEACCOUNTROUTE_COMPLETED,
  SET_CONTACT_ACTIVATEACCOUNTROUTE_FAILED,
  SET_CONTACTID_ROUTE_REQUESTED,
  SET_CONTACTID_ROUTE_ABORTED,
  SET_CONTACTID_ROUTE_COMPLETED,
  SET_CONTACTID_ROUTE_FAILED,
  RESET_CONTACTID_ROUTE_REQUESTED,
  RESET_CONTACTID_ROUTE_ABORTED,
  RESET_CONTACTID_ROUTE_COMPLETED,
  RESET_CONTACTID_ROUTE_FAILED,
  SEARCH_CONTACTS_REQUESTED,
  SEARCH_CONTACTS_COMPLETED,
  SEARCH_CONTACTS_FAILED,
  GET_USERS_ABORTED,
  GET_USERS_REQUESTED,
  GET_USERS_COMPLETED,
  GET_USERS_FAILED,
  CREATE_USER_REQUESTED,
  CREATE_USER_COMPLETED,
  CREATE_USER_FAILED,
  RESEND_USER_REQUESTED,
  RESEND_USER_COMPLETED,
  RESEND_USER_FAILED,
  CHANGE_EMAIL_REQUESTED,
  CHANGE_EMAIL_COMPLETED,
  CHANGE_EMAIL_FAILED,
  CHANGE_PASSWORD_REQUESTED,
  CHANGE_PASSWORD_COMPLETED,
  CHANGE_PASSWORD_FAILED,
  RESET_TOAST_COMPLETED,
  RESET_TOAST_REQUESTED,
  DOWNLOAD_CLIENT_USERS_REQUESTED,
  DOWNLOAD_CLIENT_USERS_COMPLETED,
  DOWNLOAD_CLIENT_USERS_FAILED,
  DOWNLOAD_ADVISER_USERS_REQUESTED,
  DOWNLOAD_ADVISER_USERS_COMPLETED,
  DOWNLOAD_ADVISER_USERS_FAILED,
  GET_CONTACT_STATUS_REQUESTED,
  GET_CONTACT_STATUS_COMPLETED,
  GET_CONTACT_STATUS_FAILED,
  RESET_CONTACT_STATUS_REQUESTED,
  RESET_CONTACT_STATUS_COMPLETED,
} from '../../actions/contacts/types';

const schema = {
  status: 'INIT', // INIT/OK/ERROR
  error: null,
  list: {},
  set: {},
  contactidroute: null,
  gettingcontactstatus: false,
  resettingcontactstatus: false,
  contactstatus: undefined,
  contactidrouteaction: {},
  redirect: null,
  redirectaction: {},
  redirectactionerror: null,
  gettingredirectaction: null,
  gotredirectaction: false,
  getredirectoneviewstatus: false,
  gotredirectoneviewstatus: false,
  redirectoneviewstatus: null,
  redirectoneviewstatuserror: null,
  settingactivateaccount: false,
  setactivateaccount: false,
  activateaccountparams: {},
  redirectroute: '',
  gettinglist: false,
  gotlist: false,
  gettingdata: false,
  gotdata: false,
  abortedlist: false,
  gettingusers: false,
  resendinguser: false,
  creatinguser: false,
  changingemail: false,
  changingpassword: false,
  admintoastmessage: false,
  resettingcontact: false,
  resettingtoast: false,
  toastmsg: '',
  gotusers: false,
  users: {
    items: {},
  },
  downloadingclientusers: false,
  downloadingadviserusers: false,
  redirectassert: null,
  searchTerm: '',
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_TOAST_REQUESTED:
      return state.set('resettingtoast', true);
    case RESET_TOAST_COMPLETED:
      return state.set('admintoastmessage', false).set('toastmsg', '');

    case SET_CONTACT_REQUESTED:
      return state.set('gettingdata', true).set('set', null);

    case SET_CONTACT_COMPLETED:
      return state
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('set', action.payload);

    case SET_CONTACT_ABORTED:
      return state.set('gettingdata', false).set('gotdata', false);

    case SET_CONTACT_FAILED:
      return state
        .set('gettingdata', false)
        .set('gotdata', false)
        .set('error', action.payload);

    case SET_CONTACT_REDIRECTRESET_COMPLETED:
      return state
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('error', null)
        .set('redirect', null)
        .set('redirectaction', null)
        .set('redirectroute', '');

    case SET_CONTACT_REDIRECT_REQUESTED:
      return state
        .set('gettingdata', true)
        .set('error', null)
        .set('redirect', null);

    case SET_CONTACT_REDIRECT_COMPLETED:
      return state
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('redirect', action.payload);

    case SET_CONTACT_REDIRECT_ABORTED:
      return state.set('gettingdata', false).set('gotdata', false);

    case SET_CONTACT_REDIRECT_FAILED:
      return state
        .set('gettingdata', false)
        .set('gotdata', false)
        .set('error', action.payload);

    case SET_CONTACT_REDIRECT_ASSERT_REQUESTED:
      return state
        .set('gettingdata', true)
        .set('error', null)
        .set('redirectassert', null);

    case SET_CONTACT_REDIRECT_ASSERT_COMPLETED:
      return state
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('redirectassert', action.payload);

    case SET_CONTACT_REDIRECT_ASSERT_ABORTED:
      return state.set('gettingdata', false).set('gotdata', false);

    case SET_CONTACT_REDIRECT_ASSERT_FAILED:
      return state
        .set('gettingdata', false)
        .set('gotdata', false)
        .set('error', action.payload);

    case SET_CONTACT_REDIRECTACTION_REQUESTED:
      return state
        .set('gettingredirectaction', action.payload)
        .set('redirectaction', null);

    case SET_CONTACT_REDIRECTACTION_COMPLETED:
      return state
        .set('gettingredirectaction', null)
        .set('gotredirectaction', true)
        .set('redirectaction', action.payload);

    case SET_CONTACT_REDIRECTACTION_ABORTED:
      return state
        .set('gettingredirectaction', null)
        .set('gotredirectaction', false);

    case SET_CONTACT_REDIRECTACTION_FAILED:
      return state
        .set('gettingredirectaction', null)
        .set('gotredirectaction', false)
        .set('redirectactionerror', action.payload);

    case RESET_CONTACT_REDIRECTACTION_COMPLETED:
      return state
        .set('gettingredirectaction', null)
        .set('gotredirectaction', false)
        .set('redirectactionerror', null)
        .set('redirectaction', null);

    case SET_CONTACT_REDIRECTONEVIEW_STATUSES_REQUESTED:
      return state
        .set('getredirectoneviewstatus', true)
        .set('redirectoneviewstatus', null);

    case SET_CONTACT_REDIRECTONEVIEW_STATUSES_COMPLETED:
      return state
        .set('getredirectoneviewstatus', false)
        .set('gotredirectoneviewstatus', true)
        .set('redirectoneviewstatus', action.payload);

    case SET_CONTACT_REDIRECTONEVIEW_STATUSES_ABORTED:
      return state
        .set('getredirectoneviewstatus', false)
        .set('gotredirectoneviewstatus', false);

    case SET_CONTACT_REDIRECTONEVIEW_STATUSES_FAILED:
      return state
        .set('getredirectoneviewstatus', false)
        .set('gotredirectoneviewstatus', false)
        .set('redirectoneviewstatuserror', action.payload);

    case SET_CONTACT_REDIRECTROUTE_REQUESTED:
      return state.set('gettingdata', true).set('redirectroute', null);

    case SET_CONTACT_REDIRECTROUTE_COMPLETED:
      return state
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('redirectroute', action.payload);

    case RESET_CONTACT_REDIRECTROUTE_COMPLETED:
      return state
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('redirectroute', '');

    case SET_CONTACT_REDIRECTROUTE_ABORTED:
      return state.set('gettingdata', false).set('gotdata', false);

    case SET_CONTACT_REDIRECTROUTE_FAILED:
      return state
        .set('gettingdata', false)
        .set('gotdata', false)
        .set('redirectErrors', action.payload);

    case SET_CONTACT_ACTIVATEACCOUNTROUTE_REQUESTED:
      return state
        .set('settingactivateaccount', true)
        .set('setactivateaccount', false)
        .set('activateaccountparams', {});

    case SET_CONTACT_ACTIVATEACCOUNTROUTE_COMPLETED:
      return state
        .set('settingactivateaccount', false)
        .set('setactivateaccount', true)
        .set('activateaccountparams', action.payload);

    case SET_CONTACT_ACTIVATEACCOUNTROUTE_FAILED:
      return state
        .set('settingactivateaccount', false)
        .set('setactivateaccount', false)
        .set('activateaccountparams', {})
        .set('error', action.payload);

    case SET_CONTACTID_ROUTE_REQUESTED:
      return state.set('gettingdata', true).set('contactidroute', null);

    case SET_CONTACTID_ROUTE_COMPLETED:
      return state
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('contactidroute', action.payload);

    case SET_CONTACTID_ROUTE_ABORTED:
      return state
        .set('gettingdata', false)
        .set('contactidroute', null)
        .set('gotdata', false);

    case SET_CONTACTID_ROUTE_FAILED:
      return state
        .set('gettingdata', false)
        .set('contactidroute', null)
        .set('gotdata', false)
        .set('error', action.payload);

    case RESET_CONTACTID_ROUTE_REQUESTED:
      return state.set('gettingdata', true).set('contactidroute', null);

    case RESET_CONTACTID_ROUTE_COMPLETED:
      return state
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('contactidroute', null);

    case RESET_CONTACTID_ROUTE_ABORTED:
      return state
        .set('gettingdata', false)
        .set('contactidroute', null)
        .set('gotdata', false);

    case RESET_CONTACTID_ROUTE_FAILED:
      return state
        .set('gettingdata', false)
        .set('contactidroute', null)
        .set('gotdata', false)
        .set('error', action.payload);

    case SET_CONTACTID_ACTION_REQUESTED:
      return state
        .set('gettinglist', true)
        .set('gotlist', false)
        .set('list', {});

    case SET_CONTACTID_ACTION_COMPLETED:
      return state
        .set('gettinglist', false)
        .set('gotlist', true)
        .set('list', action.payload);

    case SET_CONTACTID_ACTION_FAILED:
      return state
        .set('gettinglist', false)
        .set('list', {})
        .set('gotdata', false)
        .set('error', action.payload);

    case RESET_CONTACT_REQUESTED:
      return state.set('resettingcontact', true);

    case RESET_CONTACT_COMPLETED:
      return state.set('resettingcontact', false).set('set', {});

    case LIST_CONTACTS_REQUESTED:
      return state.set('error', null).set('gettinglist', true);

    case LIST_CONTACTS_COMPLETED:
      return state
        .set('error', null)
        .set('gettinglist', false)
        .set('gotlist', true)
        .set('list', action.payload);

    case LIST_CONTACTS_ABORTED:
      return state
        .set('error', null)
        .set('gettinglist', false)
        .set('gotlist', false)
        .set('abortedlist', true);

    case LIST_CONTACTS_FAILED:
      return state.set('error', action.payload);

    case SEARCH_CONTACTS_REQUESTED:
      return state
        .set('error', null)
        .set('gettinglist', true)
        .set('searchTerm', action.payload.Search);

    case SEARCH_CONTACTS_COMPLETED:
      return state
        .set('error', null)
        .set('gettinglist', false)
        .set('gotlist', true)
        .set('list', action.payload);

    case SEARCH_CONTACTS_FAILED:
      return state
        .set('error', action.payload)
        .set('gettinglist', false)
        .set('list', {});

    case GET_USERS_ABORTED:
      return state
        .set('error', null)
        .set('gettingusers', false)
        .set('users', { items: {} });

    case GET_USERS_REQUESTED:
      return state.set('error', null).set('gettingusers', true);

    case GET_USERS_COMPLETED:
      return state
        .set('error', null)
        .set('gettingusers', false)
        .set('gotusers', true)
        .set('users', action.payload);

    case GET_USERS_FAILED:
      return state.set('error', action.payload);

    case CREATE_USER_REQUESTED:
      return state
        .set('error', null)
        .set('gettingusers', true)
        .set('creatinguser', true)
        .set('admintoastmessage', false)
        .set('toastmsg', '')
        .set('users', {});

    case CREATE_USER_COMPLETED:
      return state
        .set('error', null)
        .set('gettingusers', false)
        .set('creatinguser', false)
        .set('gotusers', true)
        .set('admintoastmessage', true)
        .set('toastmsg', 'User has been created')
        .set('users', action.payload);

    case CREATE_USER_FAILED:
      return state
        .set('admintoastmessage', true)
        .set('toastmsg', action.payload.errors[0].message)
        .set('gettingusers', false)
        .set('creatinguser', false)
        .set('gotusers', true)
        .set('error', action.payload);

    case RESEND_USER_REQUESTED:
      return state
        .set('error', null)
        .set('gettingusers', true)
        .set('resendinguser', true)
        .set('admintoastmessage', false)
        .set('toastmsg', '')
        .set('users', {});

    case RESEND_USER_COMPLETED:
      return state
        .set('error', null)
        .set('gettingusers', false)
        .set('resendinguser', false)
        .set('gotusers', true)
        .set('admintoastmessage', true)
        .set('toastmsg', 'User has been resent')
        .set('users', action.payload);

    case RESEND_USER_FAILED:
      return state
        .set('admintoastmessage', true)
        .set('toastmsg', action.payload.errors[0].message)
        .set('gettingusers', false)
        .set('resendinguser', false)
        .set('gotusers', true)
        .set('error', action.payload);

    case CHANGE_EMAIL_REQUESTED:
      return state
        .set('error', null)
        .set('changingemail', true)
        .set('admintoastmessage', false)
        .set('toastmsg', '');
    case CHANGE_EMAIL_COMPLETED:
      return state
        .set('error', null)
        .set('changingemail', false)
        .set('admintoastmessage', true)
        .set('toastmsg', 'User email has been updated');
    case CHANGE_EMAIL_FAILED:
      return state
        .set('admintoastmessage', true)
        .set('toastmsg', action.payload.errors[0].message)
        .set('error', action.payload);

    case CHANGE_PASSWORD_REQUESTED:
      return state
        .set('error', null)
        .set('changingpassword', true)
        .set('admintoastmessage', false)
        .set('toastmsg', '');
    case CHANGE_PASSWORD_COMPLETED:
      return state
        .set('error', null)
        .set('changingpassword', false)
        .set('admintoastmessage', true)
        .set('toastmsg', 'User password has been reset');
    case CHANGE_PASSWORD_FAILED:
      return state
        .set('admintoastmessage', true)
        .set('toastmsg', 'Unable to reset user password, please try again.')
        .set('error', action.payload);
    case DOWNLOAD_ADVISER_USERS_REQUESTED:
      return state.set('downloadingadviserusers', true);
    case DOWNLOAD_ADVISER_USERS_COMPLETED:
      return state.set('downloadingadviserusers', false);
    case DOWNLOAD_ADVISER_USERS_FAILED:
      return state.set('downloadingadviserusers', false);
    case DOWNLOAD_CLIENT_USERS_REQUESTED:
      return state.set('downloadingclientusers', true);
    case DOWNLOAD_CLIENT_USERS_COMPLETED:
      return state.set('downloadingclientusers', false);
    case DOWNLOAD_CLIENT_USERS_FAILED:
      return state.set('downloadingclientusers', false);

    case GET_CONTACT_STATUS_REQUESTED:
      return state.set('gettingcontactstatus', true);

    case GET_CONTACT_STATUS_COMPLETED:
      return state.set('contactstatus', action.payload);

    case GET_CONTACT_STATUS_FAILED:
      return state.set('error', action.payload);

    case RESET_CONTACT_STATUS_REQUESTED:
      return state.set('resettingcontactstatus', true);

    case RESET_CONTACT_STATUS_COMPLETED:
      return state
        .set('resettingcontactstatus', false)
        .set('contactstatus', '');
    default:
      return state;
  }
};

export { initialState };

export default reducer;
